import { useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

export default function LikeButton({ liked, count, onClick }) {
  const [animating, setAnimating] = useState(false);

  const handleClick = () => {
    setAnimating(true);
    onClick();
    setTimeout(() => setAnimating(false), 300);
  };

  return (
    <motion.button onClick={handleClick} className="like-button">
      <motion.div
        animate={animating ? { scale: [1, 1.4, 1] } : {}}
        whileTap={{ scale: 0.9 }}
        transition={{ duration: 0.5 }}
      >
        <Heart
          size={18}
          fill={liked ? "#e0245e" : "none"}
          stroke={liked ? "#e0245e" : "#999"}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </motion.div>
      <span>{count}</span>
    </motion.button>
  );
}
